import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    ListWrapper: {
      marginTop: "12px",
      minHeight: "40vh",
      minWidth: "100%",
      background: theme.palette.common.white,
      border: "1px solid #009FB8",
      borderRadius: "4px",
      position: "relative",
      "&.loading": {
        background: "rgba(0, 0, 0, 0.1)",
        "& .MuiCircularProgress-root": {
          position: "absolute",
          bottom: "50%",
          left: "50%"
        }
      }
    },
    icon: {
      marginRight: "1.1rem"
    },
    info: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      margin: "24px"
    },
    MarginTop: {
      marginTop: "0px !important"
    },
    cursorPointer: {
      cursor: "pointer !important"
    },
    root: {
      marginTop: "0rem"
    },
    cursorDefault: {
      cursor: "default !important"
    }
  }),
  { name: "SearchPMTList" }
);

export default useStyles;
